import React from 'react'
import {Tabs, Cell, Checkbox, Input} from 'zarm'
import {toUpperCaseHeader, Observable} from '@utils'
import {ShowMediaCell} from '@wap/components'
import classnames from 'classnames'
import './index.less'

const {Panel} = Tabs
class ExamItemTab extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: props.data, // 检查项数据
      tabKey: 0 // 默认选中的tab
    }
  }

  componentDidMount() {
    // 在当前tabs检查项中弹出
    // 图片查看器，图片查看器的touchmove会穿透
    // 导致tabs也跟着切换
    // 利用自定义事件发布订阅解决这个问题
    this.unSubscriber = Observable.subscribe('swipe', visible => {
      if (visible) {
        this.currentTabKey = this.state.tabKey
      } else {
        // this.setState({ tabKey: this.currenttabKey });
        document
          .querySelectorAll('.examItemTabCont .za-tabs__tab')
          .forEach((dom, index) => {
            if (this.currentTabKey === index) {
              dom.click()
            }
          })
      }
    })
  }

  componentWillUnmount() {
    this.unSubscriber()
  }

  /**
   * 处理好的数据成传给保存提交
   * @returns
   */
  handleResult = () => {
    const {data} = this.state
    return data
  }

  /**
   * tab改变
   */
  onTableChange = active => {
    this.setState({tabKey: active})
  }

  /**
   * 值的改变
   * @param {*} value 指标项的value
   * @param {*} field 指标项的key
   * @param {*} type 指标项的type
   */
  onValueChange = (value, field, type) => {
    const {data} = this.state
    // 处理数据值
    if (value instanceof Array) {
      value = value.join(',').replace(/^,/, '')
    }
    // 设置数据值
    data.examContent[field] = value
    // 前缀
    const prefix = toUpperCaseHeader(type)
    // 如果是点击正常并且是选中那么要清除其他指标
    if (/^dataO[s, d]Condition$/.test(field) && value.length > 0) {
      // 清除对应数据
      ;[
        'Trichiasis',
        'BulbarConjunctiva',
        'CorneaAbnormal',
        'OtherStr'
      ].forEach(suffix => {
        data.examContent[`data${prefix}${suffix}`] = null
      })
    } else {
      data.examContent[`data${prefix}Condition`] = null
    }
    this.setState({data})
  }

  /**
   * 媒体资源改变
   * @param {Object} record
   */
  onMediaChange = record => {
    const {data} = this.state
    data.examFiles = record
    this.setState({data})
  }

  render() {
    const {data, tabKey} = this.state
    const {config = {}} = this.props
    const {examIndiList = {}} = config

    return (
      <Tabs
        swipeable
        value={tabKey}
        onChange={this.onTableChange}
        className="examItemTabCont"
      >
        {['od', 'os'].map((type, index) => {
          // 获取对应眼别的检查项的指标列表
          const examKeyList = examIndiList[`${type}List`] || []
          // 其他异常字段
          const otherStrField = `data${toUpperCaseHeader(type)}OtherStr`
          const otherStrValue = data.examContent[otherStrField]

          return (
            <Panel title={`${['OD', 'OS'][index]}`} key={type}>
              <div className="content">
                <div className="jiange" />
                {examKeyList.map((indi, index) => {
                  const {title, option = {}} = indi || {}
                  const {origin = [], key} = option
                  const value = data.examContent[key] || ''

                  return (
                    <Cell title={title} key={indi.option.key}>
                      <Checkbox.Group
                        block
                        type="button"
                        className={classnames({
                          group_content: origin.length === 3
                        })}
                        onChange={value => this.onValueChange(value, key, type)}
                        value={value.split(',')}
                      >
                        {origin.map(item => {
                          const {value, label} = item || {}
                          return (
                            <Checkbox
                              className={classnames({
                                group_item: origin.length === 3
                              })}
                              key={value}
                              value={value}
                            >
                              {label}
                            </Checkbox>
                          )
                        })}
                      </Checkbox.Group>
                    </Cell>
                  )
                })}
                <div className="other">其他异常</div>
                <Cell>
                  <Input
                    rows={3}
                    maxLength={100}
                    type="text"
                    placeholder="请输入"
                    onChange={value =>
                      this.onValueChange(value, otherStrField, type)
                    }
                    value={otherStrValue}
                  />
                </Cell>
                {/* 图片视频类型 */}
                <ShowMediaCell
                  {...this.props}
                  fileEyeType={index + 1}
                  max={10}
                  data={data.examFiles}
                  onSuccess={record => this.onMediaChange(record)}
                />
                {/* 音频 */}
                <ShowMediaCell
                  {...this.props}
                  mediaType="1" // 音视频类型 0-视频图片 1-音频 默认:0
                  max={3}
                  fileEyeType={index + 1} // 类别 1-od;2-os
                  title="语音" // title; 默认:图片和视频
                  data={data.examFiles} // 音视频数据 examFiles字段
                  onSuccess={record => this.onMediaChange(record)} // 删除和添加成功回调 返回处理后的音视频list
                />
              </div>
            </Panel>
          )
        })}
      </Tabs>
    )
  }
}

export default ExamItemTab
